module.exports = __webpack_public_path__ + "static/media/nikita_ashok.8966c0bb.png";